const DEFAULT_ITEMS = [
  "HAND-PACKED IN WELLSTON, OK",
  "NO ARTIFICIAL PRESERVATIVES",
  "21-DAY COLD CASK STEEP",
  "AUDIBLE SNAP IN EVERY BITE",
  "LOCAL PICKUP & OKLAHOMA DELIVERY",
];

export const Marquee = ({ content }) => {
  const items = content?.items?.length ? content.items : DEFAULT_ITEMS;
  const row = [...items, ...items, ...items];
  return (
    <div
      className="border-y border-parchborder bg-parchdeep py-3 overflow-hidden select-none"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((text, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-mono text-[10px] sm:text-xs uppercase tracking-[0.22em] text-dill/70 whitespace-nowrap"
              >
                <span className="px-5">{text}</span>
                <span className="text-terra">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
